import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { LoadingSpinner } from "../../../../components/LoadingSpinner"
import { loginApi } from "../../../../utils/apis/auth-service"
import { useAuth } from "../../../../utils/context/AuthContext"
import AuthPageLayout from "../../../platform-layout/components/AuthPageLayout"
import AuthHeader from "../../components/AuthHeader"
import LoginBox from "../components/LoginBox"

const LoginPage = () => {

    const navigate = useNavigate()
    const { login } = useAuth()

    const [isLoading, setIsLoading] = useState(false)
    const [passwordErrorText, setPasswordErrorText] = useState("")

    const onCreateAccountClick = () => {
        navigate("/email-registration", { state: { newsletterAccepted: false } })
    }

    const handleLoginInputsSubmit = (inputData: { [key: string]: string }) => {
        const email = inputData.email
        const password = inputData.password
        callLogin(email, password)
    }

    const callLogin = (email: string, password: string) => {
        localStorage.clear()
        setIsLoading(true)
        setPasswordErrorText("")
        loginApi(
            email,
            password,
            (result) => {
                setIsLoading(false)
                login(
                    result.idToken,
                    result.userId,
                    result.accessToken,
                    result.refreshToken,
                    result.expiryTime,
                    result.role,
                )
                navigate(`/fetch-user-data`)
            },
            (error) => {
                setPasswordErrorText("Indirizzo e-mail o password errati")
                setIsLoading(false)
            }
        )
    }

    // ********************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader actionButtonLabel="Crea un account" onActionButtonClick={onCreateAccountClick} />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-5 bg-white">
                    <LoginBox
                        onSubmit={handleLoginInputsSubmit}
                        passwordError={passwordErrorText}
                    />
                </div>
            </div>
            {
                isLoading && <LoadingSpinner />
            }
        </AuthPageLayout>
    )
}

export default LoginPage
